import { liveReload } from '@shared/services/realtime.service';
import { sortCatalog } from '@app/shared/utils/sort.utils';
import { PageLoaderComponent, PageLoad } from '@app/shared/components/page-loader/page-loader.component';
import { SelectionBarComponent } from '@app/shared/components/selection-bar/selection-bar.component';
import { CatalogImageService } from '@app/shared/services/catalog-image.service';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterChipsComponent, FilterChip } from '@app/shared/components/filter-bar/filter-chips.component';
import { SearchPillComponent } from '@app/shared/components/filter-bar/search-pill.component';
import { PageTitleComponent } from '@app/shared/components/page-title/page-title.component';
import { inject, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModulesService } from '@shared/services/modules.service';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { EquipmentsService } from '@app/shared/services/entities/equipments.service';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { UploadFileDialogService } from '@app/upload-file-dialog/upload-file-dialog.service';
//import { InventoryExcelService } from '@app/shared/services/entities/inventory-excel.service';
import { StockEquipmentsService } from '@app/shared/services/entities/stockEquipments.service';
import { PlacesService } from '@app/shared/services/entities/places.service';
import { WarehousesService } from '@app/shared/services/entities//warehouse.service';
import { MatDialog } from '@angular/material/dialog';
import { ContractsService } from '@app/shared/services/entities//contracts.service';
import { MatPaginator } from '@angular/material/paginator';
import { InventoryEquipmentsFormComponent } from './inventoryEquipments-form/inventoryEquipments-form.component';
import { InventoryEquipmentsEntryExitDateFormComponent } from './inventoryEquipmentsEntryExitDate-form/inventoryEquipmentsEntryExitDate-form.component';
import { InventoryEquipmentsChangeStatusFormComponent } from './inventoryEquipmentsChangeStatus-form/inventoryEquipmentsChangeStatus-form.component';
import { MaintenanceScheduleFormComponent } from './maintenanceSchedule-form/maintenanceSchedule-form.component';
import { MaintenanceDoneFormComponent } from './maintenanceDone-form/maintenanceDone-form.component';
import { MaintenanceCalendarFormComponent } from './maintenanceCalendar-form/maintenanceCalendar-form.component';
import { UsersService } from '@app/shared/services/entities//users.service';
import { InterventionsService } from '@app/shared/services/entities/interventions.service';
import { KitService } from '@app/shared/services/entities/kit.service';
import { GaPdfService } from '@app/shared/pdf/ga-pdf.service';
import { buildSonicisionDoc } from '@app/shared/pdf/ga-forms';
//import { OrganizationsService } from '@app/shared/services/organizations.service';
import { RolePermissionsService } from '@shared/services/auth/role-permissions.service';
import { NetworkService } from '@app/shared/services/network.service';

import { GenericExcelUploader, ColumnConfig, ValidationConfig, ExcelUploaderConfig } from '@app/shared/services/excel-upload.service';
import { SimpleExcelService } from '@app/shared/services/simple-excel.service';
import { SimpleExcelModel } from '@app/shared/models/simple-excel.model';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
import {
  InventoryToolbarComponent,
  InventoryKpi,
} from '@app/shared/components/inventory-toolbar/inventory-toolbar.component';
const log = new LoggerService('INVENTORY COMPONENT');


@Component({
  standalone: true,
  imports: [PageLoaderComponent, SelectionBarComponent, SearchPillComponent, FilterChipsComponent, PageTitleComponent, 
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    InventoryToolbarComponent,
  ],
  selector: 'app-inventoryEquipments',
  templateUrl: './inventoryEquipments.component.html',
  styleUrls: ['./inventoryEquipments.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class InventoryEquipmentComponent implements OnInit {
  private modulesSvcTitle = inject(ModulesService);
  /** Título del módulo = etiqueta visible del catálogo de Módulos. */
  title = this.modulesSvcTitle.moduleTitle('/inventoryEquipments', 'Inventario de equipos');

  isSlowConnection = false; //Validar conexión de red

  hasShippings = false; //Validar si hay traspasos hacia este almacén

  public displayedColumns = ['select', 'photo', 'equipment', 'description', 'serialNumber', 'batch', 'manufacturerYear', 'ownershipType', 'location', 'locationResponsible', 'warranty', 'numberUses', 'tagRfid', 'createdOn', 'type', 'status', 'more'];

  // ─── Alcance, vista e indicadores ───────────────────────────────────
  //
  // El inventario NO se carga hasta que haya sitio Y almacén. Antes
  // `search()` corría con `warehouse: undefined`, que en el API se traduce
  // en "todos los almacenes": una consulta cara y una tabla que mezcla
  // existencias de sitios distintos sin avisar.
  public viewMode: 'table' | 'cards' = InventoryToolbarComponent.readStoredView('equipments');

  /** KPI que está filtrando, o null. */
  public activeKpi: string | null = null;

  /** Lista completa tal como vino del API; `inventoryList` es la filtrada. */
  private allEquipments: any[] = [];

  public kpis: InventoryKpi[] = [];

  /** El equipo NO se liga a un locker: basta con la ubicación (hospital). */
  public get scopeReady(): boolean {
    return !!this.inventoryForm?.get('place')?.value;
  }

  /** Equipos del catálogo que pertenecen al hospital elegido. */
  public get equipmentsOfPlace(): any[] {
    const place = this.inventoryForm?.get('place')?.value;
    return (this.equipmentList ?? []).filter((e: any) => !place || e.place === place);
  }
  public dataSource = null;
  private readonly catalogImages = inject(CatalogImageService);
  private readonly interventionsSvc = inject(InterventionsService);
  private readonly kitSvc = inject(KitService);
  private readonly gaPdf = inject(GaPdfService);

  /** ¿Es un generador SONICISION? (equipo "GENERADOR SONICISION" del catálogo). */
  isSonicision(item: any): boolean {
    const eq: any = (this.equipmentObj as any)?.[item?.equipment] ?? {};
    return [eq.name, eq.code, eq.description, item?._equipment, item?._description]
      .some(x => String(x ?? '').toUpperCase().includes('SONICISION'));
  }

  /**
   * BITÁCORA SONICISION (formato GA-Bitacoras): cada folio donde se usó este
   * generador (por número de serie) es un USO, en orden de fecha de cirugía.
   */
  async downloadSonicisionLog(item: any): Promise<void> {
    const serial = String(item?.serialNumber ?? '').trim().toUpperCase();
    if (!serial) {
      await this.customMessageService.open({ title: 'Información', type: 'neutral', message: 'El equipo no tiene número de serie.', dismissBtn: true });
      return;
    }
    this.customMessageService.open({ title: 'Espere', type: 'neutral', message: 'Generando bitácora...', loading: true });
    try {
      const [folios, users, kits]: any[] = await Promise.all([
        this.interventionsSvc.search({ searchType: 'default', condition: { deleted: false } }),
        this.usersService.search({ searchType: 'default', condition: { deleted: false } }),
        this.kitSvc.search({ searchType: 'default', condition: { deleted: false } }),
      ]);
      const norm = (x: any) => String(x ?? '').trim().toUpperCase();
      const userName = (id: string) => ((users?.data ?? []) as any[]).find(u => u?.id === id)?.name ?? '';
      const mine = ((folios?.data ?? []) as any[])
        .filter(f => f && f.status !== 'Cancelada' && f.surgicalEquipment?.sonicisionUsed
          && [f.surgicalEquipment.generator1, f.surgicalEquipment.generator2].some(g => norm(g) === serial))
        .sort((a, b) => Date.parse(a.interventionDatetime ?? a.createdOn ?? '') - Date.parse(b.interventionDatetime ?? b.createdOn ?? ''));
      const fmt = (iso: string) => {
        const d = new Date(iso); if (isNaN(d.getTime())) return '';
        return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
      };
      const last: any = mine[mine.length - 1]?.surgicalEquipment ?? {};
      const trayName = last.tray === 'OTRA' ? (last.trayOther ?? '')
        : (((kits?.data ?? []) as any[]).find(k => k?.id === last.tray)?.name ?? '');
      const doc = buildSonicisionDoc({
        hospital: item.location ? String(this.placeObj?.[item.location] ?? '') : '',
        bitacora: serial, registro: serial,
        color: '', generator: serial,
        batteries: [last.battery1, last.battery2].filter(Boolean).join(' / '),
        charger: '', tray: trayName,
        uses: mine.map(f => ({ date: fmt(f.interventionDatetime ?? f.createdOn), folio: f.fileNumber ?? '', technician: userName(f.technician) })),
      });
      this.customMessageService.close();
      this.gaPdf.download(doc, `Bitacora-SONICISION-${serial}`);
    } catch (err) {
      this.customMessageService.close();
      await this.customMessageService.open({ title: 'Error', type: 'error', message: String(err), dismissBtn: true });
    }
  }
  public inventoryList = [];

  public contractList = [];
  public contractObj = null;
  public activeContract = null;
  
  public placeList = [];
  public placeObj: Record<string, any> = {};
  public warehouseList = [];
  public warehouseObj = null;
  public warehouseOptions = [];

  public equipmentList = [];
  public equipmentObj = [];

  public maintenanceList = [];
  public downList = [];

  public statuses = ['Activo', 'Mantenimiento','Baja'];
  public types = ['Propio','Comodato', 'Maleta'];

  public permissions = null;
  public customParams = null

  public inventoryForm: FormGroup;
  public btnSelectionWarehouse = true;
  

  @ViewChild(MatPaginator) paginator: MatPaginator;
  

  constructor(
    private inventoryEquipmentsService: StockEquipmentsService,
    private equipmentsService: EquipmentsService,
    private contractsService: ContractsService,
    private placesService:PlacesService,
    private warehousesService: WarehousesService,
    // private inventoryExcelService: InventoryExcelService,
    private customMessageService: CustomMessageService,
    private uploadFileDialog: UploadFileDialogService,
    
    private simpleExcelService:SimpleExcelService,
    private permissionsService: RolePermissionsService,
    private usersService: UsersService,
    //private organizationsService: OrganizationsService,

    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private networkService: NetworkService
  ) { }

  /** Pantalla de carga del módulo: bloquea hasta terminar la carga inicial. */
  readonly pageLoad = new PageLoad();
  /** Tiempo real: recarga cuando otro usuario cambia estos módulos (WebSocket). */
  private readonly live = liveReload(['stockEquipments', 'equipments'], () => this.pageLoad.ready && this.pageLoad.refresh(this.search()));

  ngOnInit(): void {
    this.networkService.isConnectionSlow$.subscribe(slow => {
      this.isSlowConnection = slow;
    });
    this.inventoryForm = this.formBuilder.group({
      place: [null, Validators.required],
      warehouse: [null]
    });
    void this.init();
  }

  /** Carga inicial (también la usa "Reintentar"). */
  init(): Promise<boolean> {
    return this.pageLoad.run(() => this.initialLoad());
  }

  private async initialLoad(): Promise<void> {
    await this.getRolNameByUserId();
    await this.getContracts();
    await this.getWarehouses();
    await this.getPlaces();
    await this.getEquipments();
  }

  
  /*** @description Filtro*/
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  /** Estatus elegido en la barra de filtros ('Limpiar' = todos). */
  invStatus: string = 'Limpiar';
  get statusChips(): FilterChip[] {
    return this.invStatus && this.invStatus !== 'Limpiar' ? [{ key: 'status', label: 'Estatus', value: this.invStatus }] : [];
  }
  clearStatus(): void {
    this.invStatus = 'Limpiar';
    this.statusFilter({ value: 'Limpiar' });
  }

  /**@description Filtro por estatus */
  statusFilter(event: any){
    let status = event['value'];
    if(status == 'Limpiar') this.dataSource = new MatTableDataSource(this.inventoryList);
    else this.dataSource = new MatTableDataSource(this.inventoryList.filter(x => x.status == status));
    this.dataSource.paginator = this.paginator;
  }

  /**@description Filtro por tipo */
  typeFilter(event: any){
    let type = event['value'];
    if(type == 'Limpiar') this.dataSource = new MatTableDataSource(this.inventoryList);
    else this.dataSource = new MatTableDataSource(this.inventoryList.filter(x => x.type == type));
    this.dataSource.paginator = this.paginator;
  }

  /*** @description Funcion para buscar inventario*/
  async search() {
    // Compuerta: sin sitio y almacén no se llama al API.
    if (!this.scopeReady) {
      this.allEquipments = [];
      this.inventoryList = [];
      this.maintenanceList = [];
      this.downList = [];
      this.kpis = [];
      this.dataSource = new MatTableDataSource([]);
      return;
    }
    try {
      this.inventoryList = [];
      this.maintenanceList = [];
      this.downList = [];
      this.dataSource = new MatTableDataSource(this.inventoryList);
      this.customMessageService.open({ title: 'Espere', type: 'success', message: 'Cargando inventario', loading: true });
      // Equipo por hospital: `location` = ubicación elegida. Los registros
      // viejos solo traen `warehouse`: también se incluyen los que estén en
      // un locker de este hospital.
      const place = this.inventoryForm.get('place')?.value;
      const legacyWarehouses = (this.warehouseList ?? []).filter((w: any) => w.place === place).map((w: any) => w.id);
      const [byLocation, byWarehouse]: any[] = await Promise.all([
        this.inventoryEquipmentsService.search({ condition: { deleted: false, location: place, status: this.statuses }, searchType: 'default' }),
        legacyWarehouses.length
          ? this.inventoryEquipmentsService.search({ condition: { deleted: false, warehouse: legacyWarehouses, status: this.statuses }, searchType: 'default' })
          : Promise.resolve({ state: 'success', data: [] }),
      ]);
      const merged = new Map<string, any>();
      [...((byLocation?.data ?? []) as any[]), ...((byWarehouse?.data ?? []) as any[])]
        .filter(x => x && (!x.location || x.location === place))
        .forEach(x => merged.set(x.id, x));
      const apiResponse: any = { state: byLocation?.state ?? 'success', message: byLocation?.message ?? '', data: [...merged.values()] };
      this.customMessageService.close();
      log.debug(apiResponse)
      if (apiResponse.state == 'success') {
        await this.customMessageService.open({title: '¡Hecho!', type: 'success', message: apiResponse.message, duration: 2000 });
        this.inventoryList = apiResponse.data;
        for (const inventory of this.inventoryList) {
          inventory['_equipment'] = this.equipmentObj[inventory.equipment]?.['code'];
          inventory['_description'] = this.equipmentObj[inventory.equipment]?.['description'];
          inventory['_manufacturer'] = this.equipmentObj[inventory.equipment]?.['manufacturer'];
        }
        this.maintenanceList = this.inventoryList.filter(x => x.status == 'Mantenimiento');
        this.downList = this.inventoryList.filter(x => x.status == 'Baja');
        // Se guarda la lista completa: los KPIs siempre cuentan sobre TODO
        // lo del almacén, no sobre lo que quedó filtrado. Si contaran sobre
        // lo filtrado, al activar un KPI los demás se irían a cero.
        this.allEquipments = this.inventoryList;
        this.selection.clear();
        this.buildKpis();
        this.applyKpiFilter();
        // Fotos del catálogo de Equipos (se firman aparte y se repinta).
        void this.catalogImages.resolve(this.allEquipments, r => this.equipmentObj[r.equipment]?.['image'])
          .then(() => { if (this.dataSource) this.dataSource.data = [...this.dataSource.data]; });
        this.customMessageService.close();
      }else{
        await this.customMessageService.open({title: 'Información', type: 'neutral', message: apiResponse.message, duration: 2000 }); 
        return;
      }
    }
    catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
    
  }

  /**@description Funcion para buscar equipo */
  async getEquipments(){
    try {
      this.customMessageService.open({ title: 'Espere', type: 'success', message: 'Cargando equipo', loading: true });
      let apiResponse = await this.equipmentsService.search({searchType:'default',condition:{deleted:false}});
      this.customMessageService.close();
      log.debug(apiResponse)
      if (apiResponse.state == 'success') {
        this.equipmentList = apiResponse.data;
        // Catálogo nuevo de equipos: {name, place, responsible} (sin código ni marca).
        this.equipmentList = this.applyAlphabeticSorting(this.equipmentList,'name')
        this.equipmentObj = this.equipmentList.reduce(function (r, a) {
          r[a['id']] = { code: a['name'] ?? a['code'], description: a['responsible'] ?? a['description'] ?? '', itemNumber: a['itemNumber'], manufacturer: a['manufacturer'] ?? '', place: a['place'], image: a['image'] ?? null };
          return r;
        }, Object.create(null));
      }else{
        await this.customMessageService.open({title: 'Información', type: 'neutral', message: apiResponse.message, duration: 2000 }); 
        return;
      }
    }
    catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

   /*** @description Funcion para buscar contratos*/
   async getContracts() {
    try {
      this.customMessageService.open({ title: 'Espere', type: 'neutral', message: 'Buscando contratos', loading: true });
      const apiResponse = await this.contractsService.search({searchType:'default',condition:{deleted:false}});
      this.customMessageService.close();
      if (apiResponse.state === 'success') {
        log.debug('contracts', apiResponse)
        this.contractList = apiResponse.data;
        this.contractList = this.applyAlphabeticSorting(this.contractList,'name')
        this.contractObj = this.contractList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
        this.activeContract = this.contractList.find(x=> x['status'] == true);
        if(!this.activeContract) {
          await this.customMessageService.open({ title: 'Información', type: 'neutral', message: 'Para continuar es necesario tener un contrato activo.', dismissBtn: true });  
          return;
        }
      } else {
        await this.customMessageService.open({ title: 'Información', type: 'neutral', message: apiResponse.message, duration: 2000 });
        await this.customMessageService.open({ title: 'Información', type: 'neutral', message: 'Para continuar es necesario crear un contrato.', dismissBtn: true });
        // throw new Error(apiResponse.message);
      }
    }
    catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

  /**@description Funcion para buscar almacenes */
  async getWarehouses(){
    try {
      this.customMessageService.open({ title: 'Espere', type: 'success', message: 'Cargando lockers', loading: true });
      let apiResponse = await this.warehousesService.search({searchType:'default',condition:{deleted:false}});
      this.customMessageService.close();
      log.debug(apiResponse)
      if (apiResponse.state == 'success') {
        this.warehouseList = apiResponse.data;
        this.warehouseList = this.applyAlphabeticSorting(this.warehouseList,'name')
        this.warehouseObj = this.warehouseList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      }else{
        await this.customMessageService.open({title: 'Información', type: 'neutral', message: apiResponse.message, duration: 2000 }); 
        return;
      }
    }
    catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

    /**@description Funcion para buscar almacenes */
  async getPlaces(){
    try {
      this.customMessageService.open({ title: 'Espere', type: 'success', message: 'Cargando ubicaciones', loading: true });
      let apiResponse = await this.placesService.search({searchType:'default',condition:{deleted:false}});
      this.customMessageService.close();
      log.debug(apiResponse)
      if (apiResponse.state == 'success') {
        this.placeList = apiResponse.data;
        this.placeList = this.applyAlphabeticSorting(this.placeList,'name')
        this.placeObj = this.placeList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          // Alias del sitio (así se muestra la Ubicación); nombre si no tiene.
          r[a['id']] = a['alias'] || a['name'];
          return r;
        }, Object.create(null));
      }else{
        await this.customMessageService.open({title: 'Información', type: 'neutral', message: apiResponse.message, duration: 2000 }); 
        return;
      }
    }
    catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

    /*** @description Busca almacenes relacionados al sitio */
  /**
   * El toolbar tomó el lugar de la tarjeta de "Selección de almacén".
   *
   * `inventoryForm` NO se eliminó: media docena de métodos del componente
   * (altas, cargas de xlsx, permisos) leen de ahí el almacén activo. Lo que
   * cambió es quién lo llena — antes los dos `mat-select` de la tarjeta,
   * ahora este handler.
   */
  async onScopeChange(scope: { place: string; warehouse: string }): Promise<void> {
    this.inventoryForm.get('place')?.setValue(scope.place || null);
    this.inventoryForm.get('warehouse')?.setValue(null);
    // Habilita/deshabilita el botón de alta: basta con el hospital.
    this.btnSelectionWarehouse = !scope.place;
    this.activeKpi = null;
    await this.search();
  }

  // ─── Indicadores ─────────────────────────────────────────────────────
  /**
   * Arma las tarjetas a partir de la lista COMPLETA del almacén.
   *
   * "Mantenimiento en menos de 30 días" no sale de `status`: sale de
   * `maintenanceSchedule`, que es lo programado. Se cuenta un equipo si
   * tiene al menos una fecha programada entre hoy y dentro de 30 días que
   * NO aparezca ya en `preventiveMaintenanceSchedule` (lo realizado). Sin
   * ese descuento el contador seguiría marcando servicios ya hechos.
   */
  private buildKpis(): void {
    const lista = this.allEquipments ?? [];
    const total = lista.length;
    const activos = lista.filter(x => x.status === 'Activo').length;
    const mantenimiento = lista.filter(x => x.status === 'Mantenimiento').length;
    const baja = lista.filter(x => x.status === 'Baja').length;
    const proximos = lista.filter(x => this.tieneMantenimientoProximo(x)).length;

    this.kpis = [
      { key: 'total',        label: 'Total',            icon: 'inventory_2',      value: total,         isTotal: true },
      { key: 'activo',       label: 'Activos',          icon: 'check_circle',     value: activos,       tone: 'ok' },
      { key: 'mantenimiento',label: 'En mantenimiento', icon: 'build',            value: mantenimiento, tone: 'warn' },
      { key: 'proximos',     label: 'Mtto. en 30 días', icon: 'event_available',  value: proximos,      tone: 'warn' },
      { key: 'baja',         label: 'Baja',             icon: 'do_not_disturb_on',value: baja,          tone: 'danger' },
    ];
  }

  /** `true` si tiene mantenimiento programado y pendiente dentro de 30 días. */
  private tieneMantenimientoProximo(equipo: any): boolean {
    const programado: any[] = equipo?.maintenanceSchedule ?? [];
    if (!Array.isArray(programado) || programado.length === 0) return false;

    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    const limite = new Date(hoy); limite.setDate(limite.getDate() + 30);

    // Fechas ya atendidas, para no contarlas como pendientes.
    const realizadas = new Set(
      (equipo?.preventiveMaintenanceSchedule ?? [])
        .map((m: any) => this.soloFecha(m?.date))
        .filter(Boolean)
    );

    return programado.some(m => {
      const clave = this.soloFecha(m?.date);
      if (!clave || realizadas.has(clave)) return false;
      const f = new Date(clave + 'T00:00:00');
      if (isNaN(f.getTime())) return false;
      return f >= hoy && f <= limite;
    });
  }

  /** Normaliza a `YYYY-MM-DD` para poder comparar programado contra hecho. */
  private soloFecha(valor: any): string | null {
    if (!valor) return null;
    const texto = String(valor);
    const m = texto.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
    const f = new Date(texto);
    return isNaN(f.getTime()) ? null : f.toISOString().slice(0, 10);
  }

  /** Clic en una tarjeta: prende, apaga o limpia el filtro. */
  onKpiToggle(key: string | null): void {
    this.activeKpi = key;
    this.applyKpiFilter();
  }

  onViewModeChange(mode: 'table' | 'cards'): void {
    this.viewMode = mode;
    InventoryToolbarComponent.storeView('equipments', mode);
  }

  // ─── Selección con checkbox (como en los catálogos) ─────────────────
  readonly selection = new SelectionModel<any>(true, [], true, (a, b) => a?.id != null && a.id === b?.id);
  private get visibleRows(): any[] { return (this.dataSource?.filteredData ?? []) as any[]; }
  isAllSelected(): boolean {
    const rows = this.visibleRows;
    return rows.length > 0 && rows.every(r => this.selection.isSelected(r));
  }
  isPartiallySelected(): boolean { return this.selection.hasValue() && !this.isAllSelected(); }
  toggleAllRows(): void {
    if (this.isAllSelected()) this.selection.deselect(...this.visibleRows);
    else this.selection.select(...this.visibleRows);
  }
  openImage(url: string): void { if (url) window.open(url, '_blank'); }

  /** Exporta a Excel los equipos seleccionados. */
  exportSelection(): void {
    const rows = this.selection.selected.map((r: any) => ({
      ...r,
      _equipmentName: this.equipmentObj[r.equipment]?.['code'] ?? '',
      _responsible: this.equipmentObj[r.equipment]?.['description'] ?? '',
      _location: r.location ? (this.placeObj?.[r.location] ?? '') : '',
    }));
    if (!rows.length) return;
    this.simpleExcelService.simpleXLSX({
      fileName: 'Inventario de equipo (selección)',
      sheets: [{
        sheetName: 'Selección', header: [], lineBreak: 0, data: rows,
        columns: [
          { columnKey: '_equipmentName', columnName: 'Equipo' },
          { columnKey: '_responsible', columnName: 'Responsable del equipo' },
          { columnKey: 'serialNumber', columnName: 'Número de serie' },
          { columnKey: 'batch', columnName: 'Lote' },
          { columnKey: 'manufacturerYear', columnName: 'Año de fabricación' },
          { columnKey: 'ownershipType', columnName: 'Tipo de propiedad' },
          { columnKey: '_location', columnName: 'Alias (ubicación)' },
          { columnKey: 'tagRfid', columnName: 'Etiqueta RFID' },
          { columnKey: 'type', columnName: 'Tipo' },
          { columnKey: 'status', columnName: 'Estatus' },
        ],
      }],
    } as any);
  }

  private applyKpiFilter(): void {
    const lista = this.allEquipments ?? [];
    let filtrada = lista;

    switch (this.activeKpi) {
      case 'activo':        filtrada = lista.filter(x => x.status === 'Activo'); break;
      case 'mantenimiento': filtrada = lista.filter(x => x.status === 'Mantenimiento'); break;
      case 'baja':          filtrada = lista.filter(x => x.status === 'Baja'); break;
      case 'proximos':      filtrada = lista.filter(x => this.tieneMantenimientoProximo(x)); break;
      default:              filtrada = lista;
    }

    this.inventoryList = filtrada;
    this.dataSource = new MatTableDataSource(filtrada);
    this.dataSource.paginator = this.paginator;
  }

  async findWarehouses(){
    // Cambiar de sitio invalida el almacén elegido y, con él, lo cargado.
    this.inventoryForm.get('warehouse')?.setValue(null);
    this.activeKpi = null;
    this.search();
    this.warehouseOptions = [];
    this.warehouseList.forEach(warehouse => {
      if (this.inventoryForm.value['place'] == warehouse['place']) this.warehouseOptions.push(warehouse);
    });
    //log.debug(this.warehousesOptions)
    if(this.warehouseOptions.length == 1){
      this.inventoryForm.controls['warehouse'].setValue(this.warehouseOptions[0]['id']);
      this.btnSelectionWarehouse = false;
      this.inventoryForm.disable();
      await this.search();
    }
  }

    /**
   * @description Reset warehouse selection
   */
  resetWarehouse(){
    this.btnSelectionWarehouse = true;
    this.inventoryForm.enable();
    this.inventoryForm.reset();
    this.inventoryList = []
    this.dataSource = new MatTableDataSource(this.inventoryList);
    this.hasShippings = false;
  }


  /**
   * @description Busca datos del almacen seleccionado
   */
  async setWarehouse(){
    
    if (this.inventoryForm.status == 'VALID') {
      this.btnSelectionWarehouse = false;
    }else{
      this.customMessageService.open({title: 'Cuidado', type: 'warning', message: 'Se requiere seleccionar ubicación y locker', dismissBtn: true });
      return;
    }

    this.inventoryForm.disable();
    await this.search();
    
  }

  /**@description Se abre ventana para edición o creación */
  openForm(type: string, equipmentType?: string, record?: any){
    if(type == 'update'){
      delete record['_equipment']
      delete record['_description']
      delete record['_manufacturer']
    }
    const dialogRef = this.dialog.open(InventoryEquipmentsFormComponent, {
      disableClose: true,
      data: {
        type: type,
        equipmentType: equipmentType,
        record: record,
        contract: this.contractList,
        equipments: this.equipmentsOfPlace,
        places: this.placeList,
        place: this.inventoryForm.get('place')?.value,
      },
    });

    dialogRef.afterClosed().subscribe(async result => {
      // Se recarga del API: así la tabla, los KPIs y los nombres quedan al día.
      if (result) await this.search();
    });
  }

      /**@description Se abre ventana para edición o creación */
  openEntryExitData(record?: any){
    delete record['_equipment']
    delete record['_description']
    delete record['_manufacturer']
    const dialogRef = this.dialog.open(InventoryEquipmentsEntryExitDateFormComponent, {
      disableClose: true,
      data: {
        record: record,
        contract: this.contractList,
        contractObj: this.contractObj
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
      this.search()
    });
  }

  /**@description Se abre ventana para edición o creación */
  openChangeStatus(record?: any){
    delete record['_equipment']
    delete record['_description']
    delete record['_manufacturer']
    const dialogRef = this.dialog.open(InventoryEquipmentsChangeStatusFormComponent, {
      disableClose: true,
      data: {
        record: record,
        status: this.statuses
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
      this.search()
    });
  }

    /**@description Se abre ventana para edición o creación */
  openMaintenanceSchedule(record?: any){
    delete record['_equipment']
    delete record['_description']
    delete record['_manufacturer']
    const dialogRef = this.dialog.open(MaintenanceScheduleFormComponent, {
      disableClose: true,
      data: {
        record: record,
        contract: this.contractList,
        contractObj: this.contractObj
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
      this.search()
    });
  }

  /**@description Se abre ventana para edición o creación */
  openMaintenanceDone(record?: any){
    delete record['_equipment']
    delete record['_description']
    delete record['_manufacturer']
    const dialogRef = this.dialog.open(MaintenanceDoneFormComponent, {
      disableClose: true,
      data: {
        record: record,
        contract: this.contractList,
        contractObj: this.contractObj
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
      this.search()
    });
  }

  /**@description Se abre ventana para edición o creación */
  openMaintenanceCalendar(){
    const dialogRef = this.dialog.open(MaintenanceCalendarFormComponent, {
      disableClose: true,
      data: {
        record: this.inventoryList,
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
      this.search()
    });
  }

  /**@description Funcion para eliminar equipo */
  async remove(prd: any){
    try{
      let response = await this.customMessageService.open({
        title: 'Información', 
        type: 'neutral', 
        message: `¿Esta de acuerdo en eliminar el equipo con etiqueta <b>${prd.tagRfid}</b> del inventario ?`, 
        dismissBtn: true,
        acceptBtn: true,
        acceptBtnText: 'Continuar'});
      log.debug(response);
      if(!response) return;

      let data = JSON.parse(JSON.stringify(prd));
      data['deleted'] = true
      log.debug('data', data);

      this.customMessageService.open({title: 'Espere', type: 'success', message: 'Eliminando equipo', loading: true });
      let apiResponse = await this.inventoryEquipmentsService.update({equipment: data});
      this.customMessageService.close();
      if (apiResponse.state == 'success') {
        await this.customMessageService.open({title: '¡Hecho!', type: 'success', message: 'equipo eliminando correctamente.', duration: 2000 });
        this.inventoryList = this.inventoryList.filter(x => x.id != prd.id);
        this.dataSource = new MatTableDataSource(this.inventoryList);
      }else{
        await this.customMessageService.open({title: 'Error', type: 'error', message: apiResponse['message'], dismissBtn: true });
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }
  

  /*** @description Funcion para descargar plantilla de carga de inventario*/
  downloadSampleFile() {
    let config: SimpleExcelModel = {
      fileName: 'Carga de Inventario - Archivo muestra',
      sheets: [
        {
          sheetName: 'Inventario',
          header: [],
          lineBreak: 0,
          columns: [
            { columnKey: 'equipment', columnName: 'Modelo', type: 'string' },
            { columnKey: 'serialNumber', columnName: 'No. Serie', type: 'string' },
            { columnKey: 'manufacturerYear', columnName: 'Año de fabricación', type: 'string' },
            { columnKey: 'type', columnName: 'Pertenencia', type: 'string' },
            { columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string' },
            { columnKey: 'batch', columnName: 'Lote', type: 'string' },
            { columnKey: 'ownershipType', columnName: 'Tipo de propiedad', type: 'string' },
            { columnKey: '_location', columnName: 'Alias (ubicación)', type: 'string' },
            { columnKey: 'locationResponsible', columnName: 'Responsable en ubicación', type: 'string' },
            { columnKey: 'warrantyNumber', columnName: 'Núm. garantía', type: 'string' },
            { columnKey: 'warrantyStart', columnName: 'Inicio garantía (año-mes-día)', type: 'string' },
            { columnKey: 'warrantyEnd', columnName: 'Fin garantía (año-mes-día)', type: 'string' },
          ],
          data: [{'name':'Valor 1'},{'name':'Valor 2'},{'name':'Valor 3'},{'name':'Valor 4'},{'name':'Valor 5'},{'name':'Valor 6'},{'name':'Valor 7'},{'name':'Valor 8'},{'name':'Valor 9'},{'name':'Valor 10'}]
        }
      ]
    };
    this.simpleExcelService.simpleXLSX(config)
  }

  /*** @description Funcion para descargar plantilla de carga de inventario*/
  downloadSampleMaintenanceScheduleFile() {
    let config: SimpleExcelModel = {
      fileName: 'Carga de Calendario de Mantenimiento - Archivo muestra',
      sheets: [
        {
          sheetName: 'Inventario',
          header: [],
          lineBreak: 0,
          columns: [
            { columnKey: 'equipment', columnName: 'Modelo', type: 'string' },
            { columnKey: 'serialNumber', columnName: 'No. Serie', type: 'string' },
            { columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string' },
            { columnKey: 'contract', columnName: 'Contrato', type: 'string' },
            { columnKey: 'type', columnName: 'Tipo (preventivo/correctivo)', type: 'string' },
            { columnKey: 'date', columnName: 'Fecha (año-mes-día)', type: 'string' },

          ],
          data: [{'name':'Valor 1'},{'name':'Valor 2'},{'name':'Valor 3'},{'name':'Valor 4'},{'name':'Valor 5'},{'name':'Valor 6'},{'name':'Valor 7'},{'name':'Valor 8'},{'name':'Valor 9'},{'name':'Valor 10'}]
        }
      ]
    };
    this.simpleExcelService.simpleXLSX(config)
  }

  /*** @description Funcion para descargar inventario*/
   downloadFile() {
    let config: SimpleExcelModel = {
      fileName: 'Inventario de equipos',
      sheets: [
        {
          sheetName: 'Inventario',
          header: [],
          lineBreak: 0,
          columns: [
            { columnKey: '_equipment', columnName: 'Modelo', type: 'string' },
            { columnKey: '_description', columnName: 'Descripción', type: 'string' },
            { columnKey: 'serialNumber', columnName: 'No. Serie', type: 'string' },
            { columnKey: '_manufacturer', columnName: 'Marca', type: 'string' },
            { columnKey: 'manufacturerYear', columnName: 'Año de fabricación', type: 'string' },
            { columnKey: 'type', columnName: 'Pertenencia', type: 'string' },
            { columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string' },
            { columnKey: 'batch', columnName: 'Lote', type: 'string' },
            { columnKey: 'ownershipType', columnName: 'Tipo de propiedad', type: 'string' },
            { columnKey: '_location', columnName: 'Alias (ubicación)', type: 'string' },
            { columnKey: 'locationResponsible', columnName: 'Responsable en ubicación', type: 'string' },
            { columnKey: 'warrantyNumber', columnName: 'Núm. garantía', type: 'string' },
            { columnKey: 'warrantyStart', columnName: 'Inicio garantía (año-mes-día)', type: 'string' },
            { columnKey: 'warrantyEnd', columnName: 'Fin garantía (año-mes-día)', type: 'string' },
            { columnKey: 'status', columnName: 'Estado', type: 'string' },
          ],
          // Copia con el nombre del sitio de ubicación (no se muta la lista).
          data: this.inventoryList.map((x: any) => ({ ...x, _location: x.location ? (this.placeObj[x.location] ?? '') : '' }))
        }
      ]
    };
    this.simpleExcelService.simpleXLSX(config)
  }

  /** Fecha de Excel (serial numérico, Date o texto) -> 'YYYY-MM-DD'. */
  private excelDate(value: any): string | null {
    if (value === null || value === undefined || value === '') return null;
    let date: Date;
    if (value instanceof Date) date = value;
    else if (typeof value === 'number') date = new Date(Math.round((value - 25569) * 86400 * 1000) + new Date().getTimezoneOffset() * 60000);
    else return String(value).trim().slice(0, 10) || null;
    if (isNaN(date.getTime())) return null;
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  /*** @description Funcion para cargar archivo excel*/
async openUploadFile() {
  const config: ExcelUploaderConfig = {
    columns: [
      { excelColumn: 'Modelo', objectKey: 'equipment', required: false,       catalogMapping: {
          // Nombre del equipo (TORRE 1…) dentro del hospital elegido: el nombre se repite entre hospitales.
          catalog: this.equipmentsOfPlace,
          nameField: 'name',
          idField: 'id',
          caseSensitive: false
        }},
      { excelColumn: 'No. Serie', objectKey: 'serialNumber', required: false,  transform: (value) => value?.toString()?.trim() },
      { excelColumn: 'Año de fabricación', objectKey: 'manufacturerYear', required: false,  transform: (value) => value?.toString()?.trim() },
      { excelColumn: 'Pertenencia', objectKey: 'type', required: false,  transform: (value) => value?.toString()?.trim() },
      { excelColumn: 'Etiqueta RFID', objectKey: 'tagRfid', required: false,  transform: (value) => value?.toString()?.trim() },
      { excelColumn: 'Lote', objectKey: 'batch', required: false, transform: (value) => value?.toString()?.trim() || null },
      { excelColumn: 'Tipo de propiedad', objectKey: 'ownershipType', required: false, transform: (value) => value?.toString()?.trim()?.toUpperCase() || null },
      // Ubicación: se liga por el ALIAS del catálogo de Sitios.
      // Vacío = el hospital elegido en la pantalla (el equipo se liga al hospital, no a un locker).
      { excelColumn: 'Alias (ubicación)', objectKey: 'location', required: false,
        transform: (value) => (value != null && String(value).trim() !== '')
          ? String(value).trim()
          : (this.placeList.find((p: any) => p.id === this.inventoryForm.get('place')?.value)?.alias ?? null),
        catalogMapping: {
          catalog: this.placeList.filter((p: any) => p?.active !== false),
          nameField: 'alias',
          idField: 'id',
          caseSensitive: false
        }},
      { excelColumn: 'Responsable en ubicación', objectKey: 'locationResponsible', required: false, transform: (value) => value?.toString()?.trim() || null },
      { excelColumn: 'Núm. garantía', objectKey: 'warrantyNumber', required: false, transform: (value) => value?.toString()?.trim() || null },
      { excelColumn: 'Inicio garantía (año-mes-día)', objectKey: 'warrantyStart', required: false, transform: (value) => this.excelDate(value) },
      { excelColumn: 'Fin garantía (año-mes-día)', objectKey: 'warrantyEnd', required: false, transform: (value) => this.excelDate(value) },
      {
        excelColumn: 'Locker', // Columna que no existe en el Excel: el equipo ya no se liga a un locker
        objectKey: 'warehouse',
        required: false,
        transform: () => null
      },
    ],
    validation: {
      checkExistingCodes: true,
      codeColumn: 'tagRfid',
    },
    services: {
      uploadFileDialog: this.uploadFileDialog,
      customMessageService: this.customMessageService,
      dataService: this.inventoryEquipmentsService
    },
    entityName: 'records',
    currentList: this.inventoryList,
    search: {
        condition: {deleted: false, location: this.inventoryForm.get('place')?.value}, 
        arrays: [
          {
            key: 'status',
            values: ['Activo']
          }
        ], 
        searchType: 'byArrays'},
  };
  
  const updatedData = await GenericExcelUploader.uploadExcelFile(config);
  if (updatedData) {
    // Usar los datos actualizados
    this.inventoryList = updatedData;
    this.inventoryList = this.applyAlphabeticSorting(this.inventoryList,'tagRfid')
    this.dataSource = new MatTableDataSource(this.inventoryList);
    this.dataSource.paginator = this.paginator;
    console.log('Datos actualizados:', updatedData);
  }  
}


/**
 * @description Upload maintenance of inventory
 */
async openUpdateMaintenanceFile() {
  // Leer el excel
  let items = await this.uploadFileDialog.open() as any[];
  
  this.customMessageService.open({ 
    title: "Espere",
    type: 'success', 
    message: 'Validando archivo', 
    loading: true 
  });
  
  log.debug(items);
  
  // Validar que el excel tenga las columnas requeridas
  const requiredColumns = [
    'Modelo',
    'No. Serie',
    'Etiqueta RFID',
    'Contrato',
    'Tipo (preventivo/correctivo)',
    'Fecha (año-mes-día)'
  ];
  
  if (items.length === 0) {
    this.customMessageService.close();
    this.customMessageService.open({
      title: "Espere",
      type: 'error',
      message: 'El archivo está vacío',
      duration: 5000
    });
    return null;
  }
  
  // Obtener las columnas del primer registro
  const fileColumns = Object.keys(items[0]);
  
  // Verificar que todas las columnas requeridas existan
  const missingColumns = requiredColumns.filter(col => !fileColumns.includes(col));
  
  if (missingColumns.length > 0) {
    this.customMessageService.close();
    this.customMessageService.open({
      title: "Espere",
      type: 'error',
      message: `El archivo no contiene las columnas requeridas: ${missingColumns.join(', ')}`,
      duration: 7000
    });
    return null;
  }
  
  this.customMessageService.open({ 
    title: "Espere",
    type: 'success', 
    message: 'Procesando datos', 
    loading: true 
  });
  
  // Listas para contratos y series no encontrados
  const contractsNotFound: string[] = [];
  const serialNumbersNotFound: string[] = [];
  
  // Parsear datos y validar contratos
  const parsedData = (items as any[]).map((row: any) => {
    // Buscar el contrato por nombre (case-insensitive)
    const contractName = row["Contrato"]?.trim();
    const match = this.contractList.find(
      (c: any) => c.name.trim().toLowerCase() === contractName?.toLowerCase()
    );
    
    // Si no existe el contrato, agregarlo a la lista
    if (!match && contractName) {
      if (!contractsNotFound.includes(contractName)) {
        contractsNotFound.push(contractName);
      }
    }
    
    // Convertir la fecha Excel si es numérica
    const rawDate = row["Fecha (año-mes-día)"];
    const fechaConvertida = typeof rawDate === "number" 
      ? this.excelDateToJSDate(rawDate) 
      : rawDate;
    
    return {
      ...row,
      ["Fecha (año-mes-día)"]: fechaConvertida,
      Contrato: match ? match.id : null,
      ContratoNombre: contractName
    };
  });
  
  log.debug(parsedData);
  
  // Extraer series únicas y convertirlas TODAS a string
  const uniqueSeries = [...new Set(
    items.map((row: any) => {
      const serialNumber = row["No. Serie"];
      return serialNumber != null ? String(serialNumber).trim() : '';
    })
  )].filter(s => s !== '');
  
  log.debug('Series únicas (como string):', uniqueSeries);
  
  // ✅ Agregar try-catch para manejar errores
  try {
    // Buscar equipos existentes por número de serie
    let apiResponse = await this.inventoryEquipmentsService.search({
      condition: { 
        deleted: false
      },
      arrays: [
        {
          key: 'serialNumber',
          values: uniqueSeries
        }
      ],
      searchType: 'byArrays'
    });
    
    log.debug(apiResponse);
    
    // Agrupar por No. Serie y Etiqueta RFID con la estructura requerida
    const groupedDataMap: any = parsedData.reduce((acc: any, row: any) => {
      if (row["Contrato"]) {
        const serialNumber = row["No. Serie"] != null ? String(row["No. Serie"]).trim() : '';
        const tagRfid = row["Etiqueta RFID"] != null ? String(row["Etiqueta RFID"]).trim() : '';
        const key = `${serialNumber}_${tagRfid}`;
        
        if (!acc[key]) {
          acc[key] = {
            serialNumber: serialNumber,
            tagRfid: tagRfid,
            maintenanceSchedule: []
          };
        }
        
        acc[key].maintenanceSchedule.push({
          contract: row["Contrato"],
          type: row["Tipo (preventivo/correctivo)"],
          date: row["Fecha (año-mes-día)"]
        });
      }
      
      return acc;
    }, {});
    
    const groupedData: any[] = Object.values(groupedDataMap);
    
    // Combinar groupedData con apiResponse y validar series no encontradas
    const mergedData: any[] = groupedData.reduce((acc: any[], item: any) => {
      const apiItem = apiResponse.data?.find((api: any) => 
        String(api.serialNumber).trim() === String(item.serialNumber).trim() && 
        String(api.tagRfid).trim() === String(item.tagRfid).trim()
      );
      
      if (apiItem) {
        const existingSchedule = Array.isArray((apiItem as any).maintenanceSchedule) 
          ? [...(apiItem as any).maintenanceSchedule] 
          : [];
        
        const newSchedule = [...existingSchedule, ...item.maintenanceSchedule];
        
        acc.push({
          id: (apiItem as any).id,
          serialNumber: item.serialNumber,
          tagRfid: item.tagRfid,
          maintenanceSchedule: newSchedule
        });
      } else {
        if (!serialNumbersNotFound.includes(item.serialNumber)) {
          serialNumbersNotFound.push(item.serialNumber);
        }
      }
      
      return acc;
    }, []);
    
    log.debug('Contratos no encontrados:', contractsNotFound);
    log.debug('Números de serie no encontrados:', serialNumbersNotFound);
    log.debug('Datos combinados:', mergedData);
    
    // Actualizar los registros en la base de datos
    let apiUpdateResponse: any = null;
    
    if (mergedData.length > 0) {
      this.customMessageService.open({ 
        title: "Espere",
        type: 'success', 
        message: 'Actualizando mantenimientos', 
        loading: true 
      });
      
      apiUpdateResponse = await this.inventoryEquipmentsService.update({
        operationType: 'multiple',
        records: mergedData
      });
      
      log.debug('Respuesta del update:', apiUpdateResponse);
      
      this.customMessageService.close();
      
      // Mostrar mensaje de éxito
      this.customMessageService.open({
        title: "Espere",
        type: 'success',
        message: `Se actualizaron ${mergedData.length} equipos correctamente`,
        duration: 5000
      });
    } else {
      // ✅ CERRAR mensaje si no hay datos para actualizar
      this.customMessageService.close();
    }
    
    // Mostrar mensajes de validación si hay elementos no encontrados
    if (contractsNotFound.length > 0 && serialNumbersNotFound.length > 0) {
      this.customMessageService.open({
        title: "Espere",
        type: 'warning',
        message: `Se encontraron datos no válidos. Contratos: ${contractsNotFound.join(', ')}. Números de serie: ${serialNumbersNotFound.join(', ')}`,
        duration: 7000
      });
    } else if (contractsNotFound.length > 0) {
      this.customMessageService.open({
        title: "Espere",
        type: 'warning',
        message: `Contratos no encontrados: ${contractsNotFound.join(', ')}`,
        duration: 5000
      });
    } else if (serialNumbersNotFound.length > 0) {
      this.customMessageService.open({
        title: "Espere",
        type: 'warning',
        message: `Números de serie no encontrados: ${serialNumbersNotFound.join(', ')}`,
        duration: 5000
      });
    }
    
    // ✅ Refrescar la búsqueda después de actualizar
    await this.search();
    
  } catch (error) {
    // ✅ CERRAR mensaje en caso de error
    this.customMessageService.close();
    
    log.error('Error al procesar mantenimientos:', error);
    
    this.customMessageService.open({
      title: "Espere",
      type: 'error',
      message: `Error al procesar el archivo: ${error.message || error}`,
      duration: 7000
    });
  }
}
  /**
   * @description Get rol name by user id
   */
   async getRolNameByUserId() {
    const userId = sessionStorage.getItem('userId');
    this.customMessageService.open({
      title: 'Espere',
      type: 'success',
      message: 'Cargando información de usuario',
      loading: true,
    });
    let apiResponse: any = await this.usersService.getRolNameByUserId({id: userId});
    this.customMessageService.close()
    if (apiResponse['data'][0] === null) {
      await this.customMessageService.open({
        title: 'Información',
        type: 'neutral',
        message:
          'Su usuario no cuenta con roles.<br> <b>Favor de solicitar la actualización de su usuario.</b>',
        duration: 2000,
      });
      return;
    }
    this.customParams = apiResponse['data'][0];
    this.permissions = await this.permissionsService.forRoute('/inventoryEquipments');
    this.customMessageService.close();
  }

/**
 * Cambio de formato de fecha de excel a yyyy-mm-dd.
 * @param serial Number
 */
excelDateToJSDate(serial: number): string {
  const excelEpoch = new Date(1899, 11, 30); // Excel empieza el 30 Dic 1899
  const jsDate = new Date(excelEpoch.getTime() + serial * 86400000);
  return jsDate.toISOString().split('T')[0]; // formato YYYY-MM-DD
}


/**
 * Ordena por número inicial y luego texto, insensible a mayúsculas/acentos.
 * @param data Array de objetos
 * @param key  Propiedad del objeto por la que se quiere ordenar
 */
private applyAlphabeticSorting(data, key) {
  // Por nombre: alias primero (si el catálogo lo tiene), luego nombre/código.
  if (key === 'name') return sortCatalog(data ?? []);
  const sortedData = [...data];

  const normalize = (str: string) =>
    str
      ?.toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // quitar acentos
      .replace(/\s+/g, " ") // colapsar espacios múltiples
      .trim()
      .toLowerCase() ?? "";

  sortedData.sort((a, b) => {
    const valueA = normalize(a?.[key] as string);
    const valueB = normalize(b?.[key] as string);

    if (!valueA && !valueB) return 0;
    if (!valueA) return 1;
    if (!valueB) return -1;

    const numA = parseInt(valueA, 10);
    const numB = parseInt(valueB, 10);

    // Si ambos tienen número inicial válido y son distintos
    if (!isNaN(numA) && !isNaN(numB) && numA !== numB) {
      return numA - numB;
    }

    // Si uno tiene número y el otro no
    if (!isNaN(numA) && isNaN(numB)) return -1;
    if (isNaN(numA) && !isNaN(numB)) return 1;

    // Comparar el resto del texto sin el número inicial
    const textA = valueA.replace(/^\d+\s*/, "");
    const textB = valueB.replace(/^\d+\s*/, "");

    return textA.localeCompare(textB, "es", {
      sensitivity: "base",
      ignorePunctuation: true
    });
  });

  return sortedData;
}


}
